<div class="flex f-fd--column">
  @if (isDialog) {
    <div>
      <howden-page-title></howden-page-title>
    </div>
  }

  <form [formGroup]="model.filterForm">
    <div class="flex f-gap--10px margin-bottom-10">
      <mat-form-field class="f-basis--5">
        <mat-label i18n="@@app.client.search.name">Nombre / Razón Social</mat-label>
        <input
          matInput
          [formControlName]="model.C_NAME"
          [howdenControlError]="nameError"
          maxlength="152"
        />
        <mat-error #nameError></mat-error>
      </mat-form-field>
      <mat-form-field class="f-basis--3">
        <mat-label i18n="@@app.client.search.email">Email</mat-label>
        <input
          matInput
          [formControlName]="model.C_EMAIL"
          [howdenControlError]="emailError"
          maxlength="60"
        />
        <mat-error #emailError></mat-error>
      </mat-form-field>
      <mat-form-field class="f-basis--2">
        <mat-label i18n="@@app.client.search.tax-id">NIF / CIF</mat-label>
        <input
          matInput
          [formControlName]="model.C_TAX_ID"
          [howdenControlError]="taxIdError"
          maxlength="11"
        />
        <mat-error #taxIdError></mat-error>
      </mat-form-field>
      <mat-form-field class="f-basis--2">
        <mat-label i18n="@@app.client.search.phone">Teléfono</mat-label>
        <input
          matInput
          [formControlName]="model.C_PHONE"
          [howdenControlError]="phoneError"
          maxlength="15"
        />
        <mat-error #phoneError></mat-error>
      </mat-form-field>
    </div>
    <div class="flex f-gap--10px margin-bottom-10">
      <howden-autocomplete
        class="f-basis--2"
        i18n-label="@@app.client.search.office"
        label="Oficina"
        displayField="name"
        keyField="officeId"
        [selectableItems]="model.offices"
        [formControlName]="model.C_OFFICE_ID"
      >
      </howden-autocomplete>
      <howden-autocomplete
        class="f-basis--3"
        i18n-label="@@app.client.search.executive"
        label="Ejecutivo"
        displayField="name"
        [selectableItems]="model.executives"
        [formControlName]="model.C_EXECUTIVE"
      >
      </howden-autocomplete>
      <howden-autocomplete
        class="f-basis--3"
        i18n-label="@@app.client.search.profession"
        label="Profesión"
        displayField="description"
        keyField="groupingCriteriaValueID"
        [selectableItems]="model.professions"
        [formControlName]="model.C_PROFESSION_ID"
      >
      </howden-autocomplete>
      <mat-form-field class="f-basis--2" >
        <mat-label i18n="@@app.client.search.status">Estado</mat-label>
        <mat-select [formControlName]="model.C_STATUS" [howdenControlError]="statusError">
          @for (item of model.statusValues; track item.key) {
            <mat-option [value]="item.key">
              {{ item.value }}
            </mat-option>
          }
        </mat-select>
        <mat-error #statusError></mat-error>
      </mat-form-field>
      <div class="f-basis--2 flex f-ai--center f-jc--end f-gap--10px">
        <button mat-raised-button color="primary" [disabled]="!this.model.searchIsEnable" (click)="search()">
          <mat-icon>search</mat-icon><span i18n="@@client.search.button.search">Buscar</span>
        </button>
        <button mat-raised-button color="accent" (click)="clean()">
          <mat-icon>cleaning_services</mat-icon><span i18n="@@client.search.button.clean">Limpiar</span>
        </button>
      </div>
    </div>
  </form>
  <div>
    <howden-table
      class="small-font"
      [ngClass]="{ none: !firstSearchDone }"
      keyField="id"
      paginable="server"
      sortable="server"
      filterable="server"
      [clickableRow]="true"
      [cols]="model.columns"
      [data]="model.data"
      [currentPage]="model.searchRequest.pageNumber"
      [pageSize]="model.searchRequest.pageSize"
      [totalRows]="model.length"
      [buttons]="model.buttons"
      (rowClicked)="viewClient($event)"
      (buttonClicked)="detailInfo($event)"
      (pageChanged)="onServerSideConfigChanged($event)"
      (sortChanged)="onServerSideConfigChanged($event)"
    >
    </howden-table>
  </div>
</div>